import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { product_input } from "../../../models/Product/product";
import { createProductService } from "../../../services/Product/ProductServices";
import { UseProductContext } from "../../Context/ProductContext";
import { secondColor } from "../../environment";
import Footer from "../../Footer/Footer";
import ProductCard from "../../ProductsPage/componentsProducts/ProductCard/ProductCard";
import "./CardSummary.css";

const CardSummary = () => {
  const [finish, setFinish] = useState<boolean>(false);
  const pcontex = UseProductContext();
  let nav = useNavigate();

  const productCreate = () => {
    let body: product_input = {
      name: pcontex.productName,
      description: pcontex.productDescription,
      link: pcontex.productLink,
      category: pcontex.productCategory._id,
      type: pcontex.productType.value,
      allergens: [],
      picture: pcontex.images.map((image) => {
        return { filename: image.filename, key: image.key };
      }),
      price: 0,
      discount: 0,
      available: true,
      companies: [sessionStorage.getItem("company") || ""].filter(Boolean),
    };

    createProductService(body)
      .then(() => {
        nav("/products");
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (finish) productCreate();
  }, [finish]);

  return (
    <div className="h-full flex flex-column justify-content-space-between align-items-center">
      <div className="h-full flex flex-column justify-content-center">
        <ProductCard
          product={{
            name: pcontex.productName,
            productCategory: pcontex.productCategory.name,
            productDescription: pcontex.productDescription,
            productType: pcontex.productType.label || "",
            images: pcontex.images,
          }}
        />
      </div>
      <div className="footer-position">
        <Footer
          progressbarValue={90}
          enableNextButton={pcontex.productCategory._id !== ""}
          generalColor={secondColor}
          setFinish={setFinish}
        />
      </div>
    </div>
  );
};

export default CardSummary;
